// extracted by mini-css-extract-plugin
export default {"wrapper":"VD-z","viewport":"WD-z","container":"XD-z","slide":"YD-z"};